import { Link, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { ArrowRight } from 'lucide-react'
import { ScreenTransition } from '@/components/ScreenTransition'
import { useQuiz } from '@/state/QuizContext'
import { pingScreen } from '@/lib/ping'

/**
 * Screen 1 - Intro. Quick framing, one CTA.
 *
 * Side effect: if the user lands here having already completed a quiz in this
 * tab, we clear state so the re-take is clean.
 */
export function IntroScreen() {
  const { reset, isComplete } = useQuiz()
  const navigate = useNavigate()

  useEffect(() => { pingScreen('intro') }, [])

  useEffect(() => {
    // If the user arrives at "/" via "Start over" from the result screen,
    // the context is still fully populated - reset it before they begin.
    if (isComplete) reset()
  }, [isComplete, reset])

  // Preload the loading screen eagerly - it's the first dynamic transition
  // after Finish, and we want it ready before they need it.
  useEffect(() => {
    const t = window.setTimeout(() => {
      // no-op prefetch hint - kept as a placeholder for route-level prefetch later
      void navigate
    }, 0)
    return () => window.clearTimeout(t)
  }, [navigate])

  return (
    <ScreenTransition className="fq-intro">
      <div className="fq-stack fq-stack--intro">
        <p className="fq-eyebrow">Find the gear that belongs</p>
        <h1 className="fq-h1">
          Get the
          <br />
          right fit for
          <br />
          <span className="fq-h1-accent">your body.</span>
        </h1>
        <p className="fq-lede">
          Four quick questions, sixty seconds. We'll match you with the style and length
          built around you - not a size chart.
        </p>
        <Link to="/questions/1" className="fq-cta">
          Take our quiz
          <ArrowRight size={18} aria-hidden="true" />
        </Link>
      </div>
    </ScreenTransition>
  )
}
